import {
  Box,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import timeZone from 'src/mapping/timeZone.json';
import { useUtcOffsetStore } from 'src/models/useUtcOffsetModel';

import { reportPendo } from '../../../../utils/setupPendo';
import { useLayoutStore } from '@Models/useLayoutModel';

const timeZoneItem = timeZone.timeZone;

// timeZoneItem.forEach((item, key) => {
//   // @ts-ignore
//   item.id = key + '';
// });
// console.log(timeZone);
export interface TimeZone {
  key: string;
  value: string;
  id: string;
}
function getTimeZoneKeyById(id: string) {
  return (timeZoneItem as any).find((x: TimeZone) => x.id === id).key;
}

function ConsoleSetting() {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const offsetModel = useUtcOffsetStore();
  const { layoutHeight } = useLayoutStore();
  const { t } = useTranslation();
  const [currentUtcOffsetId, setCurrentUtcOffsetId] = useState<string>('0');

  useEffect(() => {
    setCurrentUtcOffsetId(offsetModel.offsetId);
  }, [offsetModel.offsetId]);

  const handleClick = (event: any) => {
    setCurrentUtcOffsetId(event.target.getAttribute('value'));
  };
  function saveConsoleSetting() {
    offsetModel.setUtcOffsetId(currentUtcOffsetId);
    reportPendo('TimeZone.ConsoleSetting.Save.Click', {
      offset: localStorage.getItem('casUtcOffset'),
    });
    window.history.back();
  }
  return (
    <Flex position="relative" direction="column" height={layoutHeight}>
      <Box flex={6} p="8px 16px">
        <Text
          size="xl"
          fontWeight="semibold"
          pb={12}
          color={colorStyle.color.primary}
        >
          {t('header.consoleSetting.title')}
        </Text>
        <Text size="sm" pb={12} color={colorStyle.color.secondary}>
          {t('header.consoleSetting.tip')}
        </Text>
        <Flex flexDirection="row">
          <Text
            fontSize="14px"
            lineHeight="2xl"
            pr={16}
            color={colorStyle.color.secondary}
          >
            {t('header.consoleSetting.currentConsoleTime')}:
          </Text>
          <Menu defaultActiveIndex={1}>
            <MenuButton variant="secondary">
              {`(UTC${getTimeZoneKeyById(currentUtcOffsetId)}) ${t(
                'timeZone.standardName.list.' + currentUtcOffsetId
              )}`}
            </MenuButton>
            <MenuList
              maxHeight={400}
              overflowY="auto"
              onClick={handleClick}
              minWidth="100%"
              whiteSpace="nowrap"
            >
              {timeZoneItem.map(
                (
                  item: { id: string; value: string; key: string },
                  i: number
                ) => (
                  <MenuItem key={i} value={item.id}>
                    {`(UTC${item.key}) ${t(
                      'timeZone.standardName.list.' + item.id
                    )}`}
                  </MenuItem>
                )
              )}
            </MenuList>
          </Menu>
        </Flex>
      </Box>
      <Box position="absolute" bottom="0" left="0" p="20px">
        <Button
          data-track={`consoleSetting.save`}
          variant="primary"
          mr={8}
          onClick={saveConsoleSetting}
        >
          {t('common.button.save')}
        </Button>
        <Button
          variant="default"
          onClick={() => {
            window.history.back();
          }}
        >
          {t('common.button.cancel')}
        </Button>
      </Box>
    </Flex>
  );
}

export default ConsoleSetting;
